module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_11_Settings.8c009b98.png";